import React from 'react';
import { FolderOpen, CheckCircle, Clock, AlertTriangle } from 'lucide-react';
import { motion } from 'framer-motion';

interface ArchiveStatsCardsProps {
  totalDocuments: number;
  validDocuments: number;
  pendingValidation: number;
  expiredDocuments: number;
}

export default function ArchiveStatsCards({
  totalDocuments,
  validDocuments,
  pendingValidation,
  expiredDocuments,
}: ArchiveStatsCardsProps) {
  const statCards = [
    {
      label: 'Total Dokumen',
      value: totalDocuments,
      icon: FolderOpen,
      iconColor: 'text-blue-600',
      bgColor: 'bg-blue-50',
      borderColor: 'border-l-blue-500',
    },
    {
      label: 'Valid',
      value: validDocuments,
      icon: CheckCircle,
      iconColor: 'text-emerald-600',
      bgColor: 'bg-emerald-50',
      borderColor: 'border-l-emerald-500',
    },
    {
      label: 'Pending Validasi',
      value: pendingValidation,
      icon: Clock,
      iconColor: 'text-amber-600',
      bgColor: 'bg-amber-50',
      borderColor: 'border-l-amber-500',
    },
    {
      label: 'Expired',
      value: expiredDocuments,
      icon: AlertTriangle,
      iconColor: 'text-red-600',
      bgColor: 'bg-red-50',
      borderColor: 'border-l-red-500',
    },
  ];

  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 md:gap-4">
      {statCards.map((stat, index) => (
        <motion.div
          key={stat.label}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: index * 0.1 }}
        >
          <div
            className={`bg-white rounded-lg border shadow-sm border-l-4 ${stat.borderColor} p-4`}
          >
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm text-gray-500">{stat.label}</p>
                <p className="text-2xl font-bold">{stat.value}</p>
              </div>
              <div
                className={`w-12 h-12 rounded-xl ${stat.bgColor} flex items-center justify-center`}
              >
                <stat.icon className={`w-6 h-6 ${stat.iconColor}`} />
              </div>
            </div>
          </div>
        </motion.div>
      ))}
    </div>
  );
}
